import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-profile-white',
  templateUrl: './icon-profile-white.component.html',
  styles: []
})
export class IconProfileWhiteComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
